import React from 'react'

import { useCopyToClipboard } from '../../hooks/useCopyToClipboard'
import { Button } from '../button'
import { InputProps, Textarea } from '../input'

interface Props extends Pick<InputProps, 'label'> {
  className?: string
  text: string
  bottomLeftContent?: React.ReactNode
}

export const CopyToClipboard: React.FC<Props> = ({ className, label, text, bottomLeftContent }) => {
  const { isCopied, handleCopy } = useCopyToClipboard()

  return (
    <div className={className}>
      <Textarea
        label={label}
        readOnly
        onClick={(e) => e.currentTarget.select()}
        inputClass="h-12"
        data-testid="copy-to-clipboard-textarea"
        value={text}
      />
      <div className="mt-1 flex flex-wrap">
        {bottomLeftContent && <div>{bottomLeftContent}</div>}
        <Button
          className="ml-auto flex-none"
          theme="blue"
          onClick={() => handleCopy(text)}
          disabled={isCopied}
          leftContent={isCopied ? 'checkboxTick' : undefined}
          data-testid="copy-to-clipboard-copy-button"
        >
          {isCopied ? 'Copied' : 'Copy'}
        </Button>
      </div>
    </div>
  )
}
